import { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

export default function SiteFooter() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const navigate = useNavigate();

  const handleSubscribe = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    const data = new URLSearchParams({ email });
    try {
      await fetch("https://readdy.ai/api/form/d7934tb2hsar0k5m0hc0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
    } catch { /* silent */ }
    setSubscribed(true);
  };

  const go = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(href);
  };

  return (
    <footer id="footer" className="bg-[#0F2419] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand + Newsletter */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/45790feb-85e9-4db1-82d9-108a660346ef.png"
              alt="TreeTrimmingPrices.com"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Helping homeowners find fair, transparent tree service pricing since 2015. Compare local pros and get free quotes instantly.
            </p>
            <p className="text-white/80 text-sm font-semibold mb-3">Get Seasonal Tree Care Tips</p>
            {subscribed ? (
              <p className="text-green-400 text-sm font-medium flex items-center gap-2">
                <i className="ri-checkbox-circle-line"></i> Thanks for subscribing!
              </p>
            ) : (
              <form data-readdy-form id="footer-newsletter-form" onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className="flex-1 h-10 px-3 rounded-lg bg-white/10 border border-white/20 text-white text-sm placeholder-white/40 focus:outline-none focus:border-green-400 transition-colors"
                />
                <button
                  type="submit"
                  className="h-10 px-4 bg-green-600 hover:bg-green-500 text-white text-sm font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                >
                  Subscribe
                </button>
              </form>
            )}
          </div>

          {/* Pages */}
          <div>
            <p className="text-white/40 text-xs uppercase tracking-widest font-semibold mb-5">Pages</p>
            <ul className="flex flex-col gap-3">
              {[
                { label: "Home", href: "/" },
                { label: "Tree Trimming Cost Guide", href: "/cost-guide" },
                { label: "Free Quote", href: "/free-quote" },
                { label: "Service Areas", href: "/service-areas" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={go(link.href)}
                    className="text-white/70 hover:text-green-400 text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-white/40 text-xs uppercase tracking-widest font-semibold mb-5">Contact</p>
            <div className="flex flex-col gap-3">
              <a href="tel:5551234567" className="flex items-center gap-2 text-white/80 hover:text-green-400 transition-colors text-sm">
                <i className="ri-phone-line text-green-400"></i>(555) 123-4567
              </a>
              <a href="mailto:info@treetrimmingprices.com" className="flex items-center gap-2 text-white/80 hover:text-green-400 transition-colors text-sm">
                <i className="ri-mail-line text-green-400"></i>info@treetrimmingprices.com
              </a>
              <div className="flex items-start gap-2 text-white/60 text-sm">
                <i className="ri-map-pin-line text-green-400 mt-0.5"></i>
                <span>Serving Los Angeles, Simi Valley,<br />Woodland Hills, Fresno &amp; more</span>
              </div>
            </div>
            <div className="flex gap-3 mt-6">
              {[
                { icon: "ri-facebook-fill", href: "#" },
                { icon: "ri-twitter-x-line", href: "#" },
                { icon: "ri-instagram-line", href: "#" },
                { icon: "ri-youtube-line", href: "#" },
              ].map((s) => (
                <a key={s.icon} href={s.href} rel="nofollow" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-green-600 rounded-lg transition-colors cursor-pointer">
                  <i className={`${s.icon} text-white text-base`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs text-center sm:text-left">
            &copy; 2026 TreeTrimmingPrices.com. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-white/40 hover:text-white/70 text-xs transition-colors">Privacy Policy</a>
            <span className="text-white/20 text-xs">|</span>
            <a href="#" rel="nofollow" className="text-white/40 hover:text-white/70 text-xs transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
